export const SHIPPING_COMPANIES = ["aramex.svg", "dhl.svg", "fedex.svg", "ups.svg", "usps.svg"]

export const ADMIN_MENU = "Administartion"

export const DHL = 2
export const FEDEX = 5
export const SHOPINI_ECONOMY = 4
export const UPS = 8

export const CONSOLIDATED_STATUS_ID = 15

export const GLOBAL_CONSTANTS = {
    CURRENCY_VAL: "$",
    CURRENCY: "USD",
    PAGE: 1,
    PAGE_SIZE: 25,
    LOGO_PATH: "https://parcelhub.uat.shopiniworld.com/img/front/logo/",
    COMPANY: "1",
    BARCODE_DOWNLOAD_URL: `${process?.env?.REACT_APP_BASE_URL_PARCELS}/api/parcels/get-barcode/`,
    INVOICE_DOWNLOAD_URL: `${process?.env?.REACT_APP_BASE_URL_PARCELS}/api/parcels/get-invoice/`,
    AWB_DOWNLOAD_URL: `${process?.env?.REACT_APP_BASE_URL_PARCELS}/api/parcel/awb/`,
    SUITE_BARCODE_DOWNLOAD_URL: `${process?.env?.REACT_APP_BASE_URL_PARCELS}/api/parcels/get-suite-barcode/`,
    NO_WEEKS: 1
}
export const PURCHASE_REQUEST_CONSTANTS = {
    WALLET_BALANCE: 1000
}

export const PARCEL_CONSTANTS = {
    RECEIVED: 1,
    PENDING_PAYMENT: 3
}

export const UNITS: Record<string, any> = {
    1: {
        WEIGHT: "lb",
        DIM: "in"
    },
    2: {
        WEIGHT: "kg",
        DIM: "cm"
    },
    4: {
        WEIGHT: "kg",
        DIM: "cm"
    },
    5: {
        WEIGHT: "kg",
        DIM: "cm"
    }
}

export const CATEGORY_CONSTANTS: Record<string, any> = [
    {
        key: 1,
        category: "Adhesive Tape",
        hscode: 392690
    },
    {
        key: 2,
        category: "Analog Watch",
        hscode: 910229
    },
    {
        key: 3,
        category: "Apple Phone Charge",
        hscode: 854449
    },
    {
        key: 4,
        category: "Appliance Repair Parts",
        hscode: 903210
    },
    {
        key: 5,
        category: "Aromatherapy Oil",
        hscode: 330190
    },
    {
        key: 6,
        category: "Art & Craft / Stationery",
        hscode: 48173000
    },
    {
        key: 7,
        category: "Artificial Jewellery",
        hscode: 711719
    },
    {
        key: 8,
        category: "Artist Supplies",
        hscode: 960390
    },
    {
        key: 9,
        category: "Artist Supplies",
        hscode: 320990
    },
    {
        key: 10,
        category: "Arts and Craft Set",
        hscode: 950300
    },
    {
        key: 11,
        category: "Athletic Shoes",
        hscode: 640419
    },
    {
        key: 12,
        category: "Athletic Shoes",
        hscode: 640411
    },
    {
        key: 13,
        category: "Automated Data  Processing Machines",
        hscode: 847160
    },
    {
        key: 14,
        category: "Automotive Equipment & Accessories",
        hscode: 87081000
    },
    {
        key: 15,
        category: "Babies & Mothers",
        hscode: 62093090
    },
    {
        key: 16,
        category: "Baby Stroller",
        hscode: 871500
    },
    {
        key: 17,
        category: "Bluetooth Speaker",
        hscode: 851821
    },
    {
        key: 18,
        category: "Books & Magazines",
        hscode: 49019960
    },
    {
        key: 19,
        category: "Cable Holder",
        hscode: 854442
    },
    {
        key: 20,
        category: "Cameras & Accessories",
        hscode: 85258000
    },
    {
        key: 21,
        category: "Cleaner",
        hscode: 340220
    },
    {
        key: 22,
        category: "Cleaning Kit",
        hscode: 820559
    },
    {
        key: 23,
        category: "Clock, Watches and Accessories",
        hscode: 91011100
    },
    {
        key: 24,
        category: "Coffee Beans",
        hscode: 90111
    },
    {
        key: 25,
        category: "Computer Graphics Card",
        hscode: 847330
    },
    {
        key: 26,
        category: "Computer Motherboard",
        hscode: 847330
    },
    {
        key: 27,
        category: "Computers",
        hscode: 84713000
    },
    {
        key: 28,
        category: "Cosmetics",
        hscode: 330499
    },
    {
        key: 29,
        category: "Denim Jeans",
        hscode: 620419
    },
    {
        key: 30,
        category: "Deodorants",
        hscode: 330720
    },
    {
        key: 31,
        category: "Desktop Hard drive",
        hscode: 847170
    },
    {
        key: 32,
        category: "Dietary Supplements",
        hscode: 300450
    },
    {
        key: 33,
        category: "Digital Watch",
        hscode: 910212
    },
    {
        key: 34,
        category: "DVD Media",
        hscode: 852341
    },
    {
        key: 35,
        category: "Earbud Cleaner",
        hscode: 321410
    },
    {
        key: 36,
        category: "Educational Materials",
        hscode: 490199
    },
    {
        key: 37,
        category: "Electric Motor",
        hscode: 850152
    },
    {
        key: 38,
        category: "Electric Shaver",
        hscode: 851010
    },
    {
        key: 39,
        category: "Essential Oils",
        hscode: 330129
    },
    {
        key: 40,
        category: "Face Mask",
        hscode: 630710
    },
    {
        key: 41,
        category: "Filter",
        hscode: 842121
    },
    {
        key: 42,
        category: "Food",
        hscode: 21069099
    },
    {
        key: 43,
        category: "Fruit Juice Concentrate",
        hscode: 200799
    },
    {
        key: 44,
        category: "Globe",
        hscode: 490510
    },
    {
        key: 45,
        category: "Grooming Set",
        hscode: 821490
    },
    {
        key: 46,
        category: "Hair Curler",
        hscode: 851632
    },
    {
        key: 47,
        category: "Hair Preparations",
        hscode: 330590
    },
    {
        key: 48,
        category: "Hand Tools",
        hscode: 820790
    },
    {
        key: 49,
        category: "Headphones",
        hscode: 851830
    },
    {
        key: 50,
        category: "Health & Personal Care",
        hscode: 33079090
    },
    {
        key: 51,
        category: "Home Audio & Visual (AV)",
        hscode: 85437020
    },
    {
        key: 52,
        category: "Home Decoration",
        hscode: 58021900
    },
    {
        key: 53,
        category: "Imitation Jewellery",
        hscode: 711790
    },
    {
        key: 54,
        category: "Inflatable Mattress",
        hscode: 940429
    },
    {
        key: 55,
        category: "Kitchen & Household Items",
        hscode: 6912000
    },
    {
        key: 56,
        category: "kitchen Blender",
        hscode: 850980
    },
    {
        key: 57,
        category: "Laptop Computer",
        hscode: 847130
    },
    {
        key: 58,
        category: "Laser Device",
        hscode: 901320
    },
    {
        key: 59,
        category: "Lip Balm",
        hscode: 330410
    },
    {
        key: 60,
        category: "Makeup",
        hscode: 330499
    },
    {
        key: 61,
        category: "Massage Lotion",
        hscode: 330499
    },
    {
        key: 62,
        category: "Medical Apparel",
        hscode: 621142
    },
    {
        key: 63,
        category: "Men's Accessories",
        hscode: 71171110
    },
    {
        key: 64,
        category: "Men's Clothing",
        hscode: 62032000
    },
    {
        key: 65,
        category: "Men's Shoes",
        hscode: 64011000
    },
    {
        key: 66,
        category: "Mobile Phone",
        hscode: 851770
    },
    {
        key: 67,
        category: "Music, Movies, DVDs",
        hscode: 85238090
    },
    {
        key: 68,
        category: "Office Products",
        hscode: 39261000
    },
    {
        key: 69,
        category: "Oil Aroma Diffuser",
        hscode: 330749
    },
    {
        key: 70,
        category: "Oil Paint",
        hscode: 320990
    },
    {
        key: 71,
        category: "Perfume",
        hscode: 33030010
    },
    {
        key: 72,
        category: "Pet Supplies",
        hscode: 23091090
    },
    {
        key: 73,
        category: "Phone Charger",
        hscode: 851770
    },
    {
        key: 74,
        category: "Phone Phone Case",
        hscode: 392690
    },
    {
        key: 75,
        category: "Plastic Brushes",
        hscode: 960350
    },
    {
        key: 76,
        category: "Printed Education Materials",
        hscode: 490199
    },
    {
        key: 77,
        category: "Printed Matter",
        hscode: 490110
    },
    {
        key: 78,
        category: "Reading Glasses",
        hscode: 900490
    },
    {
        key: 79,
        category: "Rubber Template",
        hscode: 401693
    },
    {
        key: 80,
        category: "Sealing Stickers",
        hscode: 490890
    },
    {
        key: 81,
        category: "Shopping Bag",
        hscode: 420291
    },
    {
        key: 82,
        category: "Skin Care Appliance",
        hscode: 901910
    },
    {
        key: 83,
        category: "Socks",
        hscode: 611529
    },
    {
        key: 84,
        category: "Sports & Outdoor Equipment",
        hscode: 65061010
    },
    {
        key: 85,
        category: "Suite case / Travel Accessories",
        hscode: 42021900
    },
    {
        key: 86,
        category: "Table Lamp",
        hscode: 980490
    },
    {
        key: 87,
        category: "Tools & Home Improvement",
        hscode: 94037000
    },
    {
        key: 88,
        category: "Toys & Games",
        hscode: 95030020
    },
    {
        key: 89,
        category: "Toys and Games",
        hscode: 950390
    },
    {
        key: 90,
        category: "Tracking Tags",
        hscode: 852691
    },
    {
        key: 91,
        category: "T-Shirts",
        hscode: 610910
    },
    {
        key: 92,
        category: "USB Cords",
        hscode: 854442
    },
    {
        key: 93,
        category: "Video Game",
        hscode: 950410
    },
    {
        key: 94,
        category: "Video Games & Consoles",
        hscode: 95045000
    },
    {
        key: 95,
        category: "Watch accessories",
        hscode: 911190
    },
    {
        key: 96,
        category: "Water Flosses",
        hscode: 850980
    },
    {
        key: 97,
        category: "Whistle",
        hscode: 732999
    },
    {
        key: 98,
        category: "Women's Accessories",
        hscode: 42023900
    },
    {
        key: 99,
        category: "Women's Bags",
        hscode: 42021190
    },
    {
        key: 100,
        category: "Women's Clothing",
        hscode: 620332
    },
    {
        key: 101,
        category: "Women's Grooming",
        hscode: "96159099"
    },
    {
        key: 102,
        category: "Women's Shoes",
        hscode: 640419
    },
    {
        key: 103,
        category: "Women's Underwear",
        hscode: 610822
    }
]

export const maxWeightLimit = 2000

export const MEMBERSHIP_PLANS: Record<string, any> = {
    BASIC: "b",
    PREMIUM: "p",
    BUSINESS: "w",
    B: "Basic",
    P: "Premium",
    W: "Business"
}

export const SERVICE_TYPE = {
    0: "flat",
    1: "percentage"
}

export const CHANGE_TYPE = {
    0: "increment",
    1: "decrement"
}
export const PAYMENT_PENDING = 3

export const MEMBERSHIP_PLANS_LIST: any = [
    {
        name: "Plan Type: All",
        value: ""
    },
    {
        name: "Plan Type: Basic",
        value: "B"
    },
    {
        name: "Plan Type: Premium",
        value: "P"
    },
    {
        name: "Plan Type: Business",
        value: "W"
    }
]

export const EMAIL_VERIFICATION_DROPDOWN: any = [
    {
        name: "Email Verification: All",
        value: ""
    },
    {
        name: "Email Verification: Verified",
        value: "1"
    },
    {
        name: "Email Verification: Unverified",
        value: "0"
    }
]

export const LINEHAUL_CONSTANTS = {
    EXPORT_AGENTS: ["AIR MENZIES"],
    IMPORT_AGENTS: ["Linex", "Thabit"],
    TRACKING_COMPANIES: ["Duie Pyle INC", "Forward Air"],
    CARRIERS: ["EY (Ettihad)", "SV (Saudi)"],
    ORIGINS: ["JFK", "IAD"],
    DESTINATIONS: ["RUH", "AUH/DXB"]
}
